import DraggableApplication from "../../../DraggableApplication.jsx";
import ApplicationTopBar from "../../../ApplicationTopBar.jsx";
import React, {useRef,} from "react";
import AboutMe from "../../shared/AboutMe/AboutMe.jsx";
import Volunteering from "../../shared/AboutMe/Volunteering.jsx";
import Education from "../../shared/AboutMe/Education.jsx";
import Hobbies from "../../shared/AboutMe/Hobbies.jsx";

function AboutMeDesktopApplication({ appWindow, setWindows, onClose, onToggleVisibility, onFocus }) {
  const appContainerRef = useRef(null);

  const getContent = () => {
    switch (appWindow.content) {
      case "about":
        return <AboutMe />;
      case "education":
        return <Education />;
      case "volunteering":
        return <Volunteering />;
      case "hobbies":
        return <Hobbies />;
      default:
        return null;
    }
  };

  // forward fullscreen requests to parent
  const handleFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      appContainerRef.current?.requestFullscreen?.();
    }
  };

  const handleClick = (page) => {
    setWindows((prev) =>
      prev.map((w) =>
        w.id === appWindow.id
          ? { ...w, content: page }
          : w
      )
    );
  };

  return (
    <div className="RunningApplicationWrapper" style={{ zIndex: appWindow.order, ...appWindow.style }} onMouseDown={onFocus}>
      <DraggableApplication
        window={appWindow}
        setWindows={setWindows}
        ref={appContainerRef}
      >
        <ApplicationTopBar
          toggleVisibility={() => onToggleVisibility?.(appWindow.id)}
          close={() => onClose?.(appWindow.id)}
          setFullScreen={handleFullScreen}
          title={appWindow.title}
        />
        <div className="RunningApplication">
          <div className="applicationOptions">
            <div
              className={`ApplicationOptionsOption ${
                appWindow.content === "about" ? "active" : ""
              }`}
              onClick={() => handleClick("about")}
            >
              <h5>About Me</h5>
            </div>
            <div
              className={`ApplicationOptionsOption ${
                appWindow.content === "education" ? "active" : ""
              }`}
              onClick={() => handleClick("education")}
            >
              <h5>Education</h5>
            </div>
            <div
              className={`ApplicationOptionsOption ${
                appWindow.content === "volunteering" ? "active" : ""
              }`}
              onClick={() => handleClick("volunteering")}
            >
              <h5>Volunteering</h5>
            </div>
            <div
              className={`ApplicationOptionsOption ${
                appWindow.content === "hobbies" ? "active" : ""
              }`}
              onClick={() => handleClick("hobbies")}
            >
              <h5>Hobbies</h5>
            </div>
          </div>
          <div
            className="Contents"
            style={{
              overflow: "scroll",
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none" // IE/Edge
            }}
          >
            {getContent()}
          </div>
        </div>
      </DraggableApplication>
    </div>
  );
}
export default AboutMeDesktopApplication;